import styled from "styled-components";
import LineBg from "../../assets/pngs/subscriptionPageBg.png";

export const SubscriptionWrap = styled.div`
  width: 100%;
  position: relative;
  min-height: 100vh;
  padding-bottom: 100px;

  @media (max-width: 800px) {
    padding-bottom: 150px;
  }
  .cardswrap {
    background-position: 100% 100%;
    background-image: url(${LineBg});
    padding: 150px 0 0 0;

    & > div {
      @media (max-width: 800px) {
        flex-direction: column;
      }
    }

    h3 {
      font-weight: 600;
      font-size: 24px;
      letter-spacing: 0.03em;
      color: #2f2d51;
      width: 90%;
      text-align: center;
      margin: 70px 0 -50px 0;
    }

    .card {
      width: 372px;
      height: 362px;
      margin: 100px 0 -50px 0;
      border-radius: 16px;
      padding: 40px 0;

      @media (max-width: 400px) {
        width: 90%;
      }

      h5 {
        font-weight: 600;
        font-size: 18px;
        letter-spacing: 0.02em;
        color: #ffffff;
        text-align: center;
        @media (max-width: 400px) {
          font-size: 16px;
          width: 90%;
        }
      }
      h4 {
        font-weight: 700;
        font-size: 18px;
        letter-spacing: 0.02em;
        color: #ffffff;
        text-align: center;
        margin: 5px 0;
      }
      .bodyText {
        width: 80%;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.02em;
        color: #e8edf8;
        @media (max-width: 400px) {
          width: 90%;
        }
      }
    }
  }
  h2 {
    font-weight: 500;
    font-size: 28px;
    width: 650px;
    line-height: 35px;
    text-align: center;
    letter-spacing: -0.065em;
    color: #2f2d51;
    margin: 200px 0 50px 0;
    @media (max-width: 800px) {
      width: 90%;
      font-size: 22px;
      margin: 150px 0 50px 0;
    }
  }

  .backgroundBubbles {
    position: absolute;
    z-index: -1;
    bottom: 0;
    width: 100%;
    bottom: -200px;

    @media (max-width: 800px) {
      width: 120%;
    }
    @media (max-width: 500px) {
      bottom: 40px;
    }
  }
`;
